var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7988 17.5C29.7988 11.148 24.6508 6 18.2988 6C11.9469 6 6.79883 11.148 6.79883 17.5C6.79883 23.852 11.9469 29 18.2988 29C18.3662 29 18.4336 29 18.501 28.9955V20.0471H16.0303V17.1676H18.501V15.0473C18.501 12.59 20.0014 11.2514 22.1936 11.2514C23.2447 11.2514 24.1477 11.3277 24.4082 11.3637V13.9332H22.8988C21.7084 13.9332 21.4748 14.4992 21.4748 15.3303V17.1631H24.3273L23.9545 20.0426H21.4748V28.9955C26.2814 27.6164 29.7988 22.7514 29.7988 17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.2a9acf22785c7affffea0ac442fecfcf.svg";
export { ForwardRef as ReactComponent };